// Public candidate offer page (Phase 1d) — reached from the emailed /offer/:token
// link, no login required. The candidate reviews the offer and accepts/declines.
import { useState, useEffect } from 'react';
import { api } from './api';

const C = { primary: '#DC0069', primaryDark: '#9A0048', text: '#111927', sub: '#6C737F', border: '#E5E7EB', bg: '#F9FAFB', green: '#0B815A', red: '#B42318' };

export default function PublicOffer() {
  const token = decodeURIComponent(window.location.pathname.replace(/^\/offer\//, ''));
  const [offer, setOffer] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.publicOffer(token).then(setOffer).catch((e) => setErr(e.message));
  }, [token]);

  const decide = async (decision) => {
    setBusy(true); setErr('');
    try { setOffer(await api.decideOfferPublic(token, decision)); }
    catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  const wrap = { minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, system-ui, sans-serif', padding: 20 };
  const card = { width: '100%', maxWidth: 460, background: '#fff', border: `1px solid ${C.border}`, borderRadius: 20, padding: 32, boxShadow: '0 20px 50px rgba(16,24,40,0.08)' };

  if (err && !offer) return <div style={wrap}><div style={{ ...card, textAlign: 'center', color: C.red }}>{err}</div></div>;
  if (!offer) return <div style={wrap}><div style={card}>Loading…</div></div>;

  const decided = offer.status === 'Accepted' || offer.status === 'Declined';
  return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize: 13, fontWeight: 700, color: C.primary, letterSpacing: '0.04em', textTransform: 'uppercase' }}>{offer.company}</div>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: C.text, margin: '8px 0 4px' }}>Your offer</h1>
        <p style={{ color: C.sub, fontSize: 14, marginBottom: 20 }}>Hi {offer.candidateName}, we're delighted to offer you the {offer.role} role.</p>

        <div style={{ display: 'grid', gap: 10, padding: 16, background: C.bg, borderRadius: 14, marginBottom: 20 }}>
          <Row label="Role" value={offer.role} />
          <Row label="Annual salary" value={`Rs ${Number(offer.salary).toLocaleString('en-IN')}`} />
          <Row label="Start date" value={offer.start} />
        </div>

        {decided ? (
          <div style={{ textAlign: 'center', padding: '14px 0', fontWeight: 700, color: offer.status === 'Accepted' ? C.green : C.red }}>
            {offer.status === 'Accepted' ? '🎉 Offer accepted — welcome aboard! Check your email for next steps.' : 'Offer declined. Thank you for your time.'}
          </div>
        ) : (
          <>
            {err && <p style={{ color: C.red, fontSize: 13, marginBottom: 10 }}>{err}</p>}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => decide('Declined')} disabled={busy} style={{ flex: 1, padding: '12px', borderRadius: 12, border: `1px solid ${C.border}`, background: '#fff', color: C.sub, fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>Decline</button>
              <button onClick={() => decide('Accepted')} disabled={busy} style={{ flex: 2, padding: '12px', borderRadius: 12, border: 'none', background: C.primary, color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 14 }}>Accept offer</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const Row = ({ label, value }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
    <span style={{ color: '#6C737F' }}>{label}</span>
    <span style={{ color: '#111927', fontWeight: 600 }}>{value}</span>
  </div>
);
